"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.247 4.604C3.675 3.684 4.623 3 5.831 3h8.339c1.207 0 2.156.685 2.583 1.604.43.925.325 2.083-.524 2.946l-3.852 3.914a.27.27 0 0 0-.082.188V14.8c0 1.255-1.068 2.2-2.295 2.2s-2.294-.945-2.294-2.2v-3.148a.27.27 0 0 0-.082-.188L3.772 7.55a2.58 2.58 0 0 1-.525-2.946m1.27.59c-.202.434-.159.956.252 1.374l3.853 3.913c.306.312.484.73.484 1.17V14.8c0 .402.36.8.894.8.535 0 .895-.398.895-.8v-3.148c0-.442.177-.86.484-1.17l3.852-3.914c.411-.418.454-.94.252-1.374-.204-.44-.665-.794-1.313-.794H5.83c-.647 0-1.109.355-1.313.794",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FilterIcon20.js.map